// Removes the file extension from image filenames for gif, png, jpg and jpeg.
export function stripImageFileExtension(filename) {
    return filename.replace(/\.(gif|png|jpg|jpeg)?$/, '');
}
